import axios from '../index'

export default {
    getBancos () {
        return axios.get('/api/v1/bancos/directiva')
    },
    getCuenta() {
        return axios.get('/api/v1/bancos/tipos-de-cuentas/directiva')
    },
    getGuardarCuenta(id,formData) {
        return axios.post('/panel/actualizar-datos-bancarios/' + id, formData)
    },
    getCuentaGuardad(id) {
        return axios.get('/api/v1/personas/datos-bancarios/' + id)
    },
    getInformacion(params) {
        return axios.post('/api/v1/domiciliacion/filtrar', formData, {
            params
        })
    },
    getArchivoBancos(solicitudes){
        return axios.post('/api/v1/domiciliacion/banco/generar-archivo', solicitudes)
    },
    getGuardarSeleccionada(solicitudes){
        return axios.post('/api/v1/domiciliacion/solicitar', {solicitudes})
    },
    getEliminarCuenta(id){
        return axios.post('/panel/eliminar-datos-bancarios/' + id)
    },
    getGenerarArchivo(params){
        return axios.get('/api/v1/domiciliacion/filtrar', {params})
    },
    getCancelar(solicitud){
        return axios.post('/api/v1/domiciliacion/solicitud/' + solicitud + '/cancelar')
    }
    
}